<template>
  <div class="body evel-II">
    <zdylayout>
      <template v-slot:query-box-filed>
        <el-form
          ref="form"
          :model="form"
          label-width="80px"
          @submit.native.prevent
          class="operationControl"
          :inline="true"
          label-suffix=":"
          size="small"
        >
          <el-form-item label="试卷编号" prop="paperNumber">
            <el-input
              v-model="form.paperNumber"
              @keyup.enter.native="search"
              clearable
            ></el-input>
          </el-form-item>

          <el-form-item label="试卷名称" prop="questionsPaperName">
            <el-input
              v-model="form.questionsPaperName"
              @keyup.enter.native="search"
              clearable
            ></el-input>
          </el-form-item>

          <el-form-item label="抽题模式" prop="selectionMode">
            <el-select v-model="form.selectionMode" clearable>
              <el-option label="随机试题" value="0"></el-option>
              <el-option label="固定试题" value="1"></el-option>
            </el-select>
          </el-form-item>
          <!--          <el-col :span="6">-->
          <!--            <el-form-item label="是否开卷" prop="openBook">-->
          <!--              <el-select v-model="form.openBook" clearable>-->
          <!--                <el-option label="开卷" value="0"></el-option>-->
          <!--                <el-option label="闭卷" value="1"></el-option>-->
          <!--              </el-select>-->
          <!--            </el-form-item>-->
          <!--          </el-col>-->

          <div class="fa-pull-right">
            <el-form-item>
              <el-button type="primary" @click="search">搜索</el-button>
              <el-button @click="resetForm('form')">重置</el-button>
            </el-form-item>
          </div>
        </el-form>
      </template>
      <template v-slot:query-box-button> </template>
      <template v-slot:layer-body-front>
        <div class="fl">
          <!-- <el-button
          type="danger"
        >
          批量删除
        </el-button> -->
        &nbsp;&nbsp;
        </div>
        <div class="fa-pull-right">
            <el-button type="primary" icon="el-icon-plus" @click="
            $router.push(
              '/examination/addPaper'
            )
          ">新建</el-button>
        </div>
      </template>
      <template v-slot:body-table>
        <el-table
          class="common_tables"
          :data="paperList"
          tooltip-effect="dark"
          style="width: 100%"
          v-loading="tableLoading"
          element-loading-text="拼命加载中"
        >
          <!-- @selection-change="selectionChange" -->
          <!-- <el-table-column type="selection" width="55"></el-table-column> -->
          <el-table-column label="编号" prop="paperNumber"></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            label="试卷名称"
            prop="questionsPaperName"
          ></el-table-column>
          <el-table-column
            label="题库名称"
            :show-overflow-tooltip="true"
            prop="directoryName"
          ></el-table-column>
          <!--        <el-table-column label="抽题模式">-->
          <!--          &lt;!&ndash; 0,随机试题 1,固定试题) &ndash;&gt;-->
          <!--          <template slot-scope="scope">{{-->
          <!--              scope.row.selectionMode == 0 ? "随机试题" : "固定试题"-->
          <!--            }}-->
          <!--          </template>-->
          <!--        </el-table-column>-->
          <el-table-column
            label="试题数"
            prop="questionNumber"
            align="right" header-align="center"
          ></el-table-column>
          <el-table-column
            label="分数"
            prop="questionFractionTotal" align="right" header-align="center"
          ></el-table-column>
          <el-table-column label="时长（分）" prop="examTime" align="right" header-align="center">
            <template slot-scope="scope">
              <span
                v-if="scope.row.examTime && scope.row.examTime > 0"
                v-html="scope.row.examTime"
              >
              </span>
              <span v-else>
                不限制
              </span>
            </template>
          </el-table-column>
          <!--        <el-table-column label="是否开卷">-->
          <!--          <template slot-scope="scope">{{-->
          <!--              scope.row.openBook == 0 ? "开卷" : "闭卷"-->
          <!--            }}-->
          <!--          </template>-->
          <!--        </el-table-column>-->
          <el-table-column label="操作" width="400">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="success"
                @click="$router.push(`/student/lookExam?id=${scope.row.id}`)"
                >查看
              </el-button>
              <el-button
                v-if="scope.row.enterpriseId != '-1'"
                size="mini"
                type="primary"
                @click="
                  $router.push(
                    '/examination/addPaper?type=edit&id=' + scope.row.id
                  )
                "
                >编辑
              </el-button>
              <el-button
                size="mini"
                type="warning"
                @click="copyPaper(scope.row.id)"
                >复制试卷
              </el-button>
              <el-button
                size="mini"
                type="danger"
                @click="delPaper(scope.row.id, scope.row.enterpriseId)"
                >删除
              </el-button>
              <!--            <el-button
              v-if="isOperating()"
              size="mini" type="warning" @click="showImportDrawer(scope.row.id)"
            >导入
            </el-button>-->
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template v-slot:body-pagination>
        <div class="common_btm_pagination">
          <el-pagination
            background
            @size-change="sizeChange"
            :current-page="page"
            @current-change="pageChange"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </template>
    </zdylayout>
    <trainingPaperImport ref="trainingPaperImport"></trainingPaperImport>
  </div>
</template>

<script>
import exam from "@/api/new/exam.js";
import trainingPaperImport from "@/pages/trainingManagement/course/trainingPaperImport";

export default {
  components: { trainingPaperImport },
  data() {
    return {
      page: 1,
      pageSize: 10,
      total: 0, // 总条数
      paperList: [], // 题型列表
      form: {
        questionsPaperName: undefined,
        paperNumber: undefined,
        selectionMode: undefined,
        openBook: undefined
      },
      tableLoading: false
    };
  },
  mounted() {
    this.getPaperList();
  },
  methods: {
    openWindow(id) {
      window.open(`/student/lookExam?id=${id}`, "_blank");
    },
    copyPaper(paperId) {
      exam.copyPaper({ paperId }).then(res => {
        if (res.code == 0) {
          this.$message.success("复制试卷成功");
          this.getPaperList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    delPaper(paperId, type) {
      var enterpriseId = JSON.parse(localStorage.getItem("userinfo"))
        .enterpriseId;
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        console.log(type);
        exam
          .delPaper({ paperId, type, enterpriseId })
          .then(res => {
            if (res.code == 0) {
              this.$message.success("成功");
              this.getPaperList();
            } else {
              this.$message.error(res.message);
            }
          })
          .catch(error => {
            this.$message.error("您没有权限进行此操作,该数据为商城，不可删除");
            console.log("---------------");
            console.log(error);
          });
      });
    },
    search() {
      this.page = 1;
      this.getPaperList();
    },
    getPaperList() {
      this.tableLoading = true;
      //getPagePaperList  /getPaperList
      exam
        .getPaperListRewrite({
          page: this.page,
          pageSize: this.pageSize,
          ...this.form,
          enterpriseId: JSON.parse(localStorage.getItem("userinfo"))
            .enterpriseId
        })
        .then(res => {
          this.paperList = res.data.records;
          this.total = res.data.total;
          this.tableLoading = false;
        });
    },
    /**
     * 表格多选回调
     */
    // selectionChange(e) {
    //   console.log(e);
    // },
    //重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.search();
    },
    pageChange(e) {
      this.page = e;
      this.getPaperList();
    },
    sizeChange(e) {
      this.pageSize = e;
      this.getPaperList();
    },
    showImportDrawer(trainingPaperId) {
      this.$refs.trainingPaperImport.showImportDrawer(trainingPaperId);
    },
    /**
     * 判断是否是运营人员
     */
    isOperating() {
      let userInfo = JSON.parse(localStorage.getItem("userinfo"));
      return userInfo.isOperating;
    }
  }
};
</script>

<style>
.el-drawer.rtl {
  width: 85%;
}
</style>



// WEBPACK FOOTER //
// src/pages/examination/paperManagement.vue